<template>
  <div class="flex items-center gap-2">
    <vx-tooltip v-for="channel in selectedChannels"
                :key="channel.icon"
                position="bottom"
                :text="channel.name"
                class="flex items-center"
                :enabled="hasTooltip"
    >
      <component :is="channel.icon"
                 class="h-4 w-4"
      />
    </vx-tooltip>
  </div>
</template>

<script>
import MessengerIconColored from '@/assets/images/channels/MessengerIconColored'
import WhatsappIconColored from '@/assets/images/channels/WhatsappIconColored'
import AmioChatIconColored from '@/assets/images/channels/AmioChatIconColored'
import TelegramIconColored from '@/assets/images/channels/TelegramIconColored'
import DaktelaIconColored from '@/assets/images/channels/DaktelaIconColored'

export default {
  name: 'ChannelTypeIcons',

  components: {
    MessengerIconColored,
    WhatsappIconColored,
    AmioChatIconColored,
    TelegramIconColored,
    DaktelaIconColored
  },

  props: {
    selectedChannels: {
      type: Array,
      default: () => []
    },
    hasTooltip: {
      type: Boolean,
      required: true
    }
  }
}
</script>
